/* raw layout hash: _default-web-layout:3a518357d7388c243b818be71774b86b3fbbff68a33caa5e5adb89c98c62d32c */
import React from 'react';
import AppShell from './AppShell.jsx';

// Layout identity: `_default-web-layout`. The project's default web page shell.
// All `_default-web-layout*` variants share identical chrome, so they reuse the
// single AppShell implementation (header, slug-routed menu, account chrome,
// footer, content outlet).
export default function DefaultWebLayout() {
  return <AppShell />;
}
